export const SET_PAGESTATE = "setPageState";
export const SET_QRCODE = 'setQrcode'
export const SET_QRCODE_LIST = 'setQrcodeList'